// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26121","delete":"styles_delete__2gVLr","update":"styles_update__vAtKf","add":"styles_add__3ilQl"};